var _rect, _g, _rect2, _rect3, _g2, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicSyncIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 496,
    viewBox: "0 0 564 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.471,
    y: 0.0380859,
    width: 368.823,
    height: 288.353,
    rx: 35.7647,
    fill: "url(#paint0_linear_1750_11107)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1750_11107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.354,
    y: 17.9204,
    width: 333.059,
    height: 252.588,
    rx: 22.2504,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 295.059,
    y: 37.0967,
    width: 167.647,
    height: 11.1765,
    rx: 5.58823,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 125.215,
    width: 167.647,
    height: 344.235,
    rx: 35.7647,
    fill: "url(#paint1_linear_1750_11107)",
    fillOpacity: 0.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1750_11107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.4121,
    y: 138.627,
    width: 140.823,
    height: 317.412,
    rx: 22.2504,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2344,
    y: 149.803,
    width: 87.1764,
    height: 11.1765,
    rx: 5.58823,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.9414,
    y: 174.417,
    width: 468.642,
    height: 188.002,
    rx: 28,
    fill: "url(#paint2_linear_1750_11107)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.344 233.98C172.575 233.98 173.699 234.679 174.244 235.783L183.488 254.509L204.158 257.53C205.377 257.708 206.388 258.562 206.768 259.733C207.147 260.904 206.829 262.189 205.948 263.048L190.993 277.614L194.522 298.192C194.73 299.406 194.231 300.632 193.235 301.356C192.239 302.08 190.918 302.175 189.828 301.602L171.344 291.881L152.859 301.602C151.769 302.175 150.448 302.08 149.452 301.356C148.456 300.632 147.957 299.406 148.165 298.192L151.694 277.614L136.74 263.048C135.858 262.189 135.54 260.904 135.92 259.733C136.299 258.562 137.311 257.708 138.529 257.53L159.2 254.509L168.443 235.783C168.988 234.679 170.112 233.98 171.344 233.98ZM171.344 244.523L164.249 258.896C163.778 259.849 162.869 260.511 161.816 260.665L145.946 262.984L157.427 274.167C158.19 274.91 158.538 275.981 158.358 277.031L155.649 292.825L169.838 285.363C170.781 284.867 171.907 284.867 172.849 285.363L187.038 292.825L184.329 277.031C184.149 275.981 184.497 274.91 185.26 274.167L196.741 262.984L180.871 260.665C179.819 260.511 178.909 259.849 178.438 258.896L171.344 244.523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.372 237.212L316.903 243.682M292.286 268.298L305.581 255.003M305.581 255.003L315.285 264.707L326.607 253.386L316.903 243.682M305.581 255.003L316.903 243.682M292.286 268.298C293.957 269.946 295.284 271.908 296.193 274.071C297.102 276.234 297.574 278.556 297.582 280.902C297.59 283.249 297.133 285.573 296.239 287.743C295.345 289.912 294.03 291.883 292.371 293.542C290.712 295.201 288.741 296.516 286.572 297.41C284.402 298.304 282.078 298.761 279.731 298.753C277.385 298.745 275.063 298.273 272.9 297.364C270.737 296.455 268.775 295.128 267.127 293.457C263.886 290.102 262.093 285.608 262.133 280.943C262.174 276.279 264.045 271.816 267.344 268.518C270.642 265.219 275.104 263.348 279.769 263.308C284.434 263.267 288.928 265.06 292.283 268.301L292.286 268.298Z",
    stroke: "white",
    strokeWidth: 6.46941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.822 254.069V269.755C419.822 270.173 420.024 270.566 420.365 270.809L427.425 275.846",
    stroke: "white",
    strokeWidth: 6.47438,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.444 269.024C393.444 262.818 395.544 256.795 399.401 251.934C403.258 247.073 408.647 243.66 414.69 242.25C420.733 240.839 427.076 241.515 432.686 244.166C438.297 246.818 442.845 251.289 445.593 256.854C448.34 262.418 449.124 268.748 447.817 274.814C446.511 280.881 443.19 286.327 438.396 290.267C433.602 294.207 427.616 296.41 421.411 296.516C415.207 296.623 409.148 294.628 404.222 290.855",
    stroke: "white",
    strokeWidth: 6.47438,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M403.872 264.604L393.299 270.582C392.677 270.934 391.887 270.715 391.535 270.092L385.557 259.52",
    stroke: "white",
    strokeWidth: 6.47438,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.586 464.296C211.112 483.25 250.815 494.038 293.055 494.038C383.626 494.038 462.534 444.439 503.748 371.097",
    stroke: "url(#paint3_linear_1750_11107)",
    strokeWidth: 3.35294,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.628 49.6499L184.179 55.3896L178.439 70.9398",
    stroke: "#F8B625",
    strokeWidth: 3.35294,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.63 482.796L175.142 462.317L195.621 456.829",
    stroke: "#F8B625",
    strokeWidth: 3.35294,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.776 55.3297C155.243 67.4826 135.468 83.1709 107.297 117.469",
    stroke: "url(#paint4_linear_1750_11107)",
    strokeWidth: 3.35294,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1750_11107",
    x: 193.411,
    y: -1.02247,
    width: 370.944,
    height: 290.474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1750_11107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1750_11107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1750_11107",
    x: -5.53077,
    y: 119.684,
    width: 178.71,
    height: 355.297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1750_11107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1750_11107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1750_11107",
    x1: 378.882,
    y1: 0.0380859,
    x2: 378.882,
    y2: 288.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1750_11107",
    x1: 83.8235,
    y1: 125.215,
    x2: 83.8235,
    y2: 469.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1750_11107",
    x1: 123.948,
    y1: 295.149,
    x2: 390.553,
    y2: 121.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1750_11107",
    x1: 257.056,
    y1: 481.743,
    x2: 481.703,
    y2: 433.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8B625",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1750_11107",
    x1: 143.855,
    y1: 56.888,
    x2: 146.218,
    y2: 115.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8B625",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicSyncIllustration);
export default __webpack_public_path__ + "static/media/sonic-sync-illustration.39cc1ed101884c71c5a7f64c2d6e119e.svg";
export { ForwardRef as ReactComponent };